<template>
	<section class="promotions main-content align-center">
		<div class="row row-header align-center">
			<h2 class="subtitle">{{ subtitle }}</h2>
			<h2>{{ header }}</h2>
		</div>
		<div class="row promotions-row flex-row slide-row">
			<client-only>
				<nuxt-link
					v-for="promoblock in promoblocks.slice(0, 4)"
					:key="promoblock.ID"
					:to="localePath(`/${promoblock.link}`)"
					class="slick-item columns column3"
				>
					<div class="img-wrapper">
						<picture>
							<source v-if="promoblock.imageWebp" :srcset="promoblock.imageWebp" type="image/webp" />
							<source :srcset="promoblock.image" />
							<img loading="lazy" :src="promoblock.image" :alt="promoblock.imageAlt" />
						</picture>
					</div>
					<div class="slick-slide-content">
						<div class="slick-slide-header">
							<h3>{{ promoblock.header }}</h3>
							<span>
								{{ promoblock.button }}
								<font-awesome-icon icon="fa-light fa-arrow-right-long" size="1x" />
							</span>
						</div>
						<div v-parse-links v-html="promoblock.content" />
					</div>
				</nuxt-link>
			</client-only>
		</div>
	</section>
</template>

<script setup>
defineProps({
	subtitle: { type: String, default: '' },
	promoblocks: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
});

const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
.slick-item {
	border-bottom: 1px solid var(--subtitle-color);

	p,
	:deep(p) {
		color: var(--body-color);
	}
}

.slick-slide-header {
	justify-content: flex-start;
}
</style>
